import { jsxs, jsx } from 'react/jsx-runtime';
import { useDatePickerContext } from '../context/datePickerContext.mjs';
import getMonthCountInRange from '../utils/getMonthCountInRange.mjs';
import { useLinearLocale } from '../../locale/LocaleContext.mjs';
import { localeValue } from '../constants/localeValues.mjs';
import { localeValues } from './localeValues.mjs';
import ControllerContainer from './base/ControllerContainer.mjs';

const MonthController_NAME = "MonthController";
const DatePickerMonthController = ({
  children,
  __scopeDatePicker,
  ...props
}) => {
  const {
    mode,
    startDate,
    endDate,
    selectedDate,
    clearSelected,
    excludeDates
  } = useDatePickerContext(MonthController_NAME, __scopeDatePicker);
  const { locale } = useLinearLocale();
  const isRangeMode = mode === "range";
  const singleModeCount = !isRangeMode && selectedDate !== null ? 1 : 0;
  const rangeModeCount = isRangeMode && startDate !== null && endDate !== null ? getMonthCountInRange(startDate, endDate, excludeDates) : 0;
  const selectedDateCount = Math.max(
    isRangeMode ? rangeModeCount : singleModeCount,
    0
  );
  const rangeLabel = isRangeMode && selectedDateCount > 0 ? localeValue[locale].monthCount(selectedDateCount) : "";
  if (typeof children === "function") {
    return children({
      selectedDateCount,
      isRangeMode
    });
  }
  const notAllowedToClear = isRangeMode ? startDate === null && endDate === null : selectedDate === null;
  return /* @__PURE__ */ jsxs(ControllerContainer, { ...props, children: [
    /* @__PURE__ */ jsx(ControllerContainer.InfoText, { children: isRangeMode && rangeLabel ? rangeLabel : localeValue[locale].optionalInputDescription }),
    /* @__PURE__ */ jsx(
      ControllerContainer.ClearButton,
      {
        disabled: notAllowedToClear,
        onClick: clearSelected,
        children: localeValues[locale].clear
      }
    )
  ] });
};

export { DatePickerMonthController as default };
//# sourceMappingURL=MonthController.mjs.map
